import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Alert,
  Input,
  Label,
  Row,
} from "reactstrap";
import OrderStatusManager from "./OrderStatusManager";
import ReactToPrint from "react-to-print";
import moment from "moment";
import Switch from "react-switch";
import Countdown from "react-countdown-now";
import RequestManager from "../../singletons/RequestManager";
import Confirm from "./Confirm";
//import RejectComments from "./RejectComments";
import ConfirmReject from "./ConfirmReject";
import InvoiceBill from "./InvoiceBill";
import OrderItemInactive from "./OrderItemInactive";
import StockCartItemPrice from "../../components/StockCartItemPrice/StockCartItemPrice";
import config from "../../config";
import {
  SDK_NGX_NIX,
  SDK_NGX_ASHWA,
  SDK_CHROME,
  SDK_CHROME_ELECTRON,
  SDK_SUNMI_MINI_T1,
  SDK_SUNMI_PRO2,
} from "../../config/Constants";
import LoginError from "../../components/LoginError/LoginError";
import ConfirmPayatCounter from "./ConfirmPayatCounter";

import LoadingOverlay from "react-loading-overlay";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
const orderStatusManager = new OrderStatusManager();

// Renderer callback with condition
const rendererTimer = ({ minutes, seconds, completed }) => {
  if (completed) {
    // Render a complete state
    return (
      <p
        style={{
          alignItems: "center",
          padding: 2,
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        00:00{" "}
      </p>
    );
  } else {
    // Render a countdown
    return (
      <p
        style={{
          alignItems: "center",
          padding: 2,
          fontSize: 25,
          justifyContent: "center",
        }}
      >
        {minutes}:{seconds}
      </p>
    );
  }
};
export default class DetailedOrderCard extends Component {
  constructor(props) {
    super(props);
    this.rejectText = "";
    var updprice = {};
    

    this.state = {
      updprice:null,
      timeLeft: "00:00",
      cartItemValue:null,
      orderId: null,
      orderModalVisible: false,
      order: null,
      printRef: null,
      printRollCount: 0,
      spinnerLoading: false,
      comments: "",
      commentsModalVisible: false,
      loginErrorMessage: "",
      loginModalVisible: false,
      payAtCounterModalVisible: false,
      invoicePrint: null,
      printKOTFun: "",
      invoicePrintFun: "",
      itemInactiveVisible: false,
      selectedItemInactive: null,
      priceModalVisible: false,
      selectedStock: null,
      selectedCartItem:null,
      togglerefresh:false,
      taxInclusive:false,
      order_summary:"",
      chromePrinters:"",
      fetchPrinterInfo:false,
      forcePrinterSelection:false,
      deliveryPersonFirstName:"",
      deliveryPersonPhone:"",
    };
  }

  componentWillMount() {
    this.get_checkout_details();
    this.getKOTDetails();
    this.getInvoiceDetails();

    this.fetchOrderDetails();
    console.log("node id", this.props.order);
    console.log("node id", this.props.order.node.cart);
  }

  componentDidMount() {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    // const canAutoPrintKot = storeInformation && storeInformation.store && storeInformation.store.canAutoPrintKot
    // if(canAutoPrintKot){
    //   let requestManager = new RequestManager();
    //   requestManager.getStoreDetails();
    //   this.updateOrderStatus("ACCEPTED");
    // }
  }
  toggleChange = (cartItem) => {
    this.setState({
      isChecked: !cartItem.status,
    });
  };

  togglePricetModal = () => {
    this.setState({
      priceModalVisible: !this.state.priceModalVisible,
    });
  };
  togglesetrefresh = () => {
    this.setState({
      togglerefresh: !this.state.togglerefresh,
    });
  };
  
  updateCartItemPrice = async (CARTITEM, PRICE) => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let params = {
      input: {
        id:CARTITEM,
        unitprice: parseFloat(PRICE)
      },
    };

    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "UpdateCartItemFulfilmentPrice",
      params
    );
    if (response.error === null) {
      //this.updateSkuPrice();
      console.log("UpdateCartItemFulfilmentPrice", JSON.stringify(response));
      this.setState({ spinnerLoading: false });
      
      //window.location.reload(false);
    } else {
      this.setState({ spinnerLoading: false });
      alert("Unable to update inventory. Please check your internet connection.");
      
      //);
    }
    return 'SUCCESS'
  };
  getCountOfItems = () => {
    let cartItems = this.state.order.node.cart.cartItems.edges;
    let quantity = 0;
    cartItems.forEach((cartItem) => {
      quantity = quantity + cartItem.node.quantity;
    });

    return quantity;
  };

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible,
    });
  };
  toggleCommentsModal = () => {
    this.setState({
      commentsModalVisible: !this.state.commentsModalVisible,
    });
  };

  toggleInvoiceModal = () => {
    this.setState({
      invoiceBillVisible: !this.state.invoiceBillVisible,
    });
  };

  fromAndroid = (data) => {
    if (window.totDevice) {
      window.totDevice.postMessage(JSON.stringify(data));
    }
  };

 
  render() {
    const { spinnerLoading } = this.state;

    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <div>
          <Modal
            size="lg"
            isOpen={this.state.loginModalVisible}
            toggle={this.toggleErrorLoginModal}
          >
            <LoginError
              editable={true}
              loginErrorMessage={this.state.loginErrorMessage}
              goBack={this.toggleErrorLoginModal}
            />
          </Modal>

          <Modal
            size="lg"
            isOpen={this.state.payAtCounterModalVisible}
            toggle={this.toggleConfirmPayatCounter}
          >
            <ConfirmPayatCounter
              editable={true}
              order={this.state.order}
              goBack={this.toggleConfirmPayatCounter}
            />
          </Modal>
          <Modal
            size="lg"
            isOpen={this.state.itemInactiveVisible}
            toggle={this.toggleOrderItemInactiveModal}
          >
            <OrderItemInactive
              editable={true}
              item={this.state.selectedItemInactive}
              goBack={this.toggleOrderItemInactiveModal}
            />
          </Modal>
          <Modal
            size="lg"
            isOpen={this.state.priceModalVisible}
            toggle={this.togglePricetModal}
          >
            <StockCartItemPrice
              goBack={this.togglePricetModal}
              refreshInventory={this.getInventory}
              stock={this.state.selectedStock}
              cartItem={this.state.selectedCartItem}
            />
          </Modal>

          {this.state.order === null ? (
            <div>
              <ModalHeader toggle={this.props.goBack}></ModalHeader>
              <ModalBody>
                <p>{"Getting Order Details."}</p>
              </ModalBody>
            </div>
          ) : (
            <div>
              {
                // <Modal
                //   size="lg"
                //   isOpen={this.state.commentsModalVisible}
                //   toggle={this.toggleCommentsModal}
                // >
                //   <RejectComments
                //     editable={true}
                //     order={this.state.order}
                //     toggleOrderDetails={this.fetchOrderDetails}
                //     goBack={this.toggleCommentsModal}
                //   />
                // </Modal>
              }
              <Modal
                size="lg"
                isOpen={this.state.commentsModalVisible}
                toggle={this.toggleCommentsModal}
              >
                <ConfirmReject
                  editable={true}
                  order={this.state.order}
                  storeInformation={this.props.storeInformation}
                  toggleBackMain={this.goBackMain}
                  goBack={this.toggleCommentsModal}
                />
              </Modal>

              <Modal
                size="lg"
                isOpen={this.state.orderModalVisible}
                toggle={this.toggleModal}
              >
                <Confirm
                  editable={true}
                  order={this.state.order}
                  toggleFullFilled={this.toggleFullFilled}
                  goBack={this.toggleModal}
                />
              </Modal>
              <Modal
                size="lg"
                isOpen={this.state.invoiceBillVisible}
                toggle={this.toggleInvoiceModal}
              >
                <InvoiceBill
                  editable={true}
                  order={this.state.order}
                  goBack={this.toggleInvoiceModal}
                />
              </Modal>
              <ModalBody>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginBottom: 15,
                    paddingBottom: 10,
                    borderBottom: "1px solid #ECECEC",
                  }}
                >
                  {this.state.order.node.status === "PUSHED"
                    ? this.renderActionAcceptAndReject()
                    : this.props.storeInformation.store &&
                      this.props.storeInformation.store.printSdkType &&
                      this.props.storeInformation.store.isPrintEnabled === true
                    ? this.renderPrintButton()
                    : null}
                  {this.state.order === null ? null : (
                    <div hidden={true}>{this.renderPrintComponent()}</div>
                  )}

                  <Button
                    style={{ color: "white", backgroundColor: "red" }}
                    onClick={this.props.goBack}
                  >
                    {" "}
                    Close
                  </Button>
                </div>
                <div>
                  {this.props.storeInformation.store &&
                  this.props.storeInformation.store.canMarkCouldReject ===
                    true &&
                  this.state.order.node.status === "ACCEPTED" ? (
                    <Button
                      style={{
                        color: "white",
                        backgroundColor: "red",
                        margin: 10,
                      }}
                      onClick={() => {
                        // Peri added to make a modal popup for reject
                        this.toggleCommentsModal();
                      //   if (
                      //     this.state.order &&
                      //     this.state.order.node.comments !== null
                      //   ) {
                      //     this.updateOrderStatus("REJECTED");
                      //   } else {
                      //     this.toggleErrorLoginModal(
                      //       "Enter reason in comments "
                      //     );
                      //   }
                       }}
                    >
                      Reject
                    </Button>
                  ) : null}
                  {/* <Button
                    style={{
                      color: "white",
                      backgroundColor: "green",
                      marginBottom: 10,
                    }}
                    onClick={() => {
                      this.setState({ invoiceBillVisible: true });
                    }}
                  >
                    {" "}
                    InvoiceBill
                  </Button>
                  {this.state.order.node.cart.checkout.mode == 'DELIVERY' && ( 
                  <Button
                    style={{
                      color: "white",
                      backgroundColor: "green",
                      marginBottom: 10,
                    }}
                    onClick={() => {
                      this.openGoogleMaps()
                    }}
                  >
                    {" "}
                    Navigate
                  </Button>
                  )} */}
                  {this.getPaymentMode() === "PAY_AT_COUNTER" &&
                  this.getPayment() !== "PAID" ? (
                    <Button
                      style={{
                        color: "white",
                        marginLeft: 10,
                        marginBottom: 10,
                        backgroundColor: "red",
                      }}
                      onClick={() => {
                        this.setState({ payAtCounterModalVisible: true });
                      }}
                    >
                      {"Pay at counter"}
                    </Button>
                  ) : null}
                  
                  {this.props.storeInformation.store &&
                  this.props.storeInformation.store.canMarkReady === true
                    ? this.renderReadyActionButton()
                    : this.renderDeliveredActionButton()}
                  <Row style={{ marginLeft: 10, marginTop: 10 }}>
                    <p style={{ padding: 0, fontWeight: "bold" }}>v10 Payment:</p>
                    <p
                      style={{
                        marginLeft: 10,
                        marginBottom: 10,
                        fontWeight: "bold",
                        height: 30,
                        padding: 4,
                        alignItems: "center",
                        textAlign: "center",
                        color: "white",
                        backgroundColor:
                          this.getPaymentBackgroudColor() === true
                            ? "green"
                            : "red",
                      }}
                    >
                      {this.getPayment()}
                    </p>
                  </Row>
                  
                  {this.getPaymentMode() === "PAY_AT_COUNTER" ? (
                    <p
                      style={{
                        margin: 0,
                        padding: 0,
                        fontWeight: "bold",
                      }}
                    >
                      {"Payment Mode: Pay at counter"}
                    </p>
                  ) : null}
                  {this.getPayment() !== "PAID" ? (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {"Total pending amount: ₹" +
                        this.state.order.node.cart.checkout.total}
                    </p>
                  ) : null}

                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {"Token: " + this.getToken()}
                  </p>

                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {"Mode: " + this.props.order.node.cart.checkout.mode}
                    {/* {(this.props.order.node.cart.checkout.mode === "DELIVERY" && this.props.order.node.support !== null && this.props.order.node.support.userProfile !== null && this.props.order.node.support.userProfile.user !== null)
                    ? " Claimed by: " + (this.props.order.node.support.userProfile.user.phone|| '') + " " + (this.props.order.node.support.userProfile.firstName|| '') + " "  + (this.props.order.node.support.userProfile.lastName|| '')
                    : null} */}
                    
                    {(this.props.order.node.cart.checkout.mode === "DELIVERY" && this.props.order.node.support !== null && this.state.deliveryPersonPhone !== null && this.state.deliveryPersonFirstName !== null)
                    ? " Claimed by: " + (this.state.deliveryPersonPhone|| '') + " " + (this.state.deliveryPersonFirstName|| '') 
                    : null}

                  </p> 

                  {this.getDeliveryLocation() === "" ? null || undefined  : (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {this.getDeliveryLocation()}
                    </p>
                  )}
                  {this.getDeliverySlot() === "" ? null || undefined : (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {this.getDeliverySlot()}
                    </p>
                  )}
                  {this.state.order.node.invoiceNo === null ? null : (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {"InVoice Number: " + this.state.order.node.invoiceNo}
                    </p>
                  )}
                  {this.state.order.node.comments === null ? null : (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {"Comments: " + this.state.order.node.comments}
                    </p>
                  )}

                  {this.props.order.node.cart.checkout.codeType === "AEP" ? (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {this.props.order.node.cart.checkout.codeType +
                        ": " +
                        this.props.order.node.cart.checkout.code}
                    </p>
                  ) : null}

                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {"Store Name: " +
                      this.state.order.node.cart.pickupPoint.store.name 
                      /*+
                      " " +
                      this.state.order.node.cart.pickupPoint.name
                      */
                      }
                      
                  </p>
                  {this.props.order.node.cart.checkout.deliveryLocation !==
                  null ? (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {"Region: " +
                        this.state.order.node.cart.pickupPoint.store.region
                          .name}
                    </p>
                  ) : null}
            
                <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                  {this.state.order.node.cart.pickupPoint.store.fetchCutomerDetails === true 
                  // && this.state.order.node.cart.checkout.payments.edges[0].node.mode === 'PREPAID_ORDER'
                  ? "User Mobile: " + this.state.order.node.tempCustomerPhone
                  : "User Mobile: " + this.state.order.node.user.phone}
                  {/* {"User Mobile: " + this.state.order.node.user.phone} */}
                  </p>
                  {this.state.order.node.user.userProfile.firstName ===
                  null ? null : (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                     {this.state.order.node.cart.pickupPoint.store.fetchCutomerDetails === true 
                    //  && this.state.order.node.cart.checkout.payments.edges[0].node.mode === 'PREPAID_ORDER'
                  ?  "User Name: " + (this.state.order.node.tempCustomerFirstname || '') + " " + (this.state.order.node.tempCustomerLastname || '')
                  : "User Name: " + (this.state.order.node.user.userProfile.firstName || '') + " " + (this.state.order.node.user.userProfile.lastName || '')}

                       {/* {"User Name: " +
                         this.state.order.node.user.userProfile.firstName +
                         " " +
                         this.state.order.node.user.userProfile.lastName} */}
                    </p>
                  )}

                  {this.state.order.node.cart.specialInstructions ===
                  null ? null : (
                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                      {"Special Instructions: " +
                        this.state.order.node.cart.specialInstructions}
                    </p>
                  )}

                  <p style={{ margin: 0, padding: 0 }}>
                    {this.getCountOfItems() + " Item(s)"}
                  </p>
                  <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
                    {"OrderID: " + this.state.order.node.orderId}
                  </p>
                  <p style={{ margin: 0, padding: 0 }}>
                    {"Order Push:" +
                      moment(
                        this.state.order.node.pushedAt === null
                          ? this.state.order.node.createdAt
                          : this.state.order.node.pushedAt
                      ).format("MMMM Do YYYY, h:mm a")}
                  </p>
                  {this.state.order && this.state.order.node.deliveryEndtime === null
                   ? null : (
                  <p style={{ margin: 0, padding: 0 }}>
                  
                    {"Delivery At:" +
                      moment(
                        this.state.order && this.state.order.node.deliveryEndtime != null
                          ? this.state.order.node.deliveryEndtime
                          : null
                      ).format("MMMM Do YYYY, h:mm a")}
                  </p>
                   )}
                  <div>
                    <Label style={{ fontStyle: "bold", marginTop: 10 }}>
                      {"Comments:"}
                    </Label>
                    <Input
                      style={{ marginTop: 10 }}
                      type="text"
                      placeholder="Enter comments"
                      onChange={(event) => {
                        this.rejectText = event.target.value;
                      }}
                    />

                    <Button
                      color="success"
                      style={{ paddingLeft: 25, margin: 10, paddingRight: 25 }}
                      onClick={() => {
                        if (this.rejectText.length > 1) {
                          this.updateSupportCommentsOrder();
                        } else {
                          this.toggleErrorLoginModal(
                            "Atleast one character should be their"
                          );
                        }
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                  <Table responsive style={{ marginTop: 20, marginBottom: 20 }}>
                    <tbody>
                      <tr>
                        <th>Product</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                        {this.props.bussiness === "Grocery" ? (
                          <th>Fullfilment</th>
                        ) : null}
                      </tr>
                      {this.state.order.node.cart.cartItems.edges.map(
                        (cartItem) => (
                          <tr key={cartItem.node.id}>
                            <td>
                              <div style={{}}>
                                <p>{this.getProductName(cartItem)}</p>
                                {this.getLocalChinaProductName(cartItem) ===
                                "" ? (
                                  ""
                                ) : (
                                  <p>
                                    {this.getLocalChinaProductName(cartItem)}
                                  </p>
                                )}

                                {cartItem.node.customizations.edges.length >
                                0 ? (
                                  <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <p
                                        style={{
                                          marginBottom: 10,
                                          marginTop: 10,
                                          padding: 0,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {"Customizations"}
                                      </p>
                                      <p
                                        style={{
                                          marginBottom: 10,
                                          marginTop: 10,
                                          padding: 0,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {"Amount"}
                                      </p>
                                    </div>
                                    {cartItem.node.customizations.edges.map(
                                      (customization) => {
                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "row",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <p>
                                              {customization.node.parent.name +
                                                " - " +
                                                customization.node.name}
                                            </p>
                                            {this.getLocalChinaProductName(
                                              cartItem
                                            ) === "" ? (
                                              <p>
                                                {"₹" +
                                                  customization.node
                                                    .settlementPrice}
                                              </p>
                                            ) : (
                                              <p>
                                                {"$" +
                                                  customization.node
                                                    .settlementPrice}
                                              </p>
                                            )}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                ) : null}
                              </div>
                            </td>
                            <td>
                              <div>
                                <p>{cartItem.node.quantity} </p>
                                {this.getLocalChinaProductName(cartItem) ===
                                "" ? (
                                  ""
                                ) : (
                                  <p>{cartItem.node.quantity} </p>
                                )}
                              </div>
                            </td>

                            <td>{this.getItemPrice(cartItem)}</td>
                            <td>
                              {this.props.bussiness === "Grocery" ? (
                                this.props.pastOrder === true ? (
                                  <Switch
                                    disabled={true}
                                    onChange={(checked) => {}}
                                    checked={
                                      cartItem.node.status === "FULFILLED"
                                        ? true
                                        : false
                                    }
                                  />
                                ) : (
                                  <div
                                    style={{
                                      justifyItems: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Switch
                                      disabled={
                                        this.props.bussiness === "Grocery"
                                          ? cartItem.node.status === "FULFILLED"
                                            ? false
                                            : true
                                          : true
                                      }
                                      onChange={(checked) => {
                                        this.setState({
                                          orderModalVisible: true,
                                          orderId: cartItem.node.id,
                                        });
                                      }}
                                      checked={
                                        cartItem.node.status === "FULFILLED"
                                          ? true
                                          : false
                                      }
                                    />
                                    {cartItem.node.status === "FULFILLED" && (
                                    <form>
                                     <Input
                                      style={{ marginTop: 10 }}
                                          type="Number"
                                          placeholder="Update Price"
                                          onchange = {this.handleInputChange}
                                          id={cartItem.node.id}
                                          
                                          />
                                     <Button name={cartItem.node.id} style={{marginLeft: 10, backgroundColor:"#1E90FF"}} 
                                     onClick={this.handlebuttonclick}
                                    
                                     >
                                       Save Price
                                      </Button>
                                      </form>  
                                   )}
                                  </div>
                                )
                              ) : null}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                  {this.renderAdditionalCharges(
                    this.state.order.node.cart.settlementExtra,
                    this.state.order.node.cart.cartItems.edges[0]
                  )}
                  {this.getLocalChinaProductName(
                    this.state.order.node.cart.cartItems.edges &&
                      this.state.order.node.cart.cartItems.edges[0]
                  ) === "" ? (
                    <p
                      style={{
                        margin: 0,
                        padding: 0,
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {"Total Price: ₹" + this.state.order.node.cart.total}
                    </p>
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        padding: 0,
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {"Total Price: $" + this.state.order.node.cart.total}
                    </p>
                  )}
                </div>
              </ModalBody>
              <ModalFooter>{this.renderActionButtons()}</ModalFooter>
            </div>
          )}
        </div>
      </LoadingOverlay>
    );
  }
  handleInputChange(event) {
    
    const value = event.target.value
    const id = event.target.id;

    this.setState({
      id: value
    });
  }
 

  handlebuttonclick=(event) =>{
    const name = event.target.name;
    const nvalue = document.getElementById(name).value;
    this.updateCartItemPrice(name,nvalue);
    this.fetchOrderDetails();
    this.togglesetrefresh()
    
  }
  
  get_checkout_details = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    console.log(
      "params",
      JSON.stringify({
        checkout_id: this.props.order.node.cart.checkout.id,
      })
    );
    // region_name
    try {
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/product/get_invoice_details/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            checkout_id: this.props.order.node.cart.checkout.id,
          }),
        }
      );

      console.log("get_invoice_details", response);

      if (response.status === 200) {
        let json = await response.json();
        let res = json.result;
        console.log("res", res);
        this.setState({ invoicePrint: res });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  

  printRest = async (message) => {
    try {
      var jsonKOTBody = "";
     // const chromePrintersObject = JSON.parse(this.state.chromePrinters);
      const chromePrintersObject = typeof this.state.chromePrinters === "string" 
      ? JSON.parse(this.state.chromePrinters)
      : this.state.chromePrinters;
      if( this.state.forcePrinterSelection && chromePrintersObject.KOTPRINTER && (Array.isArray(chromePrintersObject.KOTPRINTER)) && chromePrintersObject.KOTPRINTER.length > 0)
      { 
        if(chromePrintersObject.pageSize){

        jsonKOTBody = JSON.stringify({
          gngprint: message,
          KOTPRINTER: chromePrintersObject.KOTPRINTER,
          pageSize: chromePrintersObject.pageSize
        })
      }else{
        jsonKOTBody = JSON.stringify({
          gngprint: message,
          KOTPRINTER: chromePrintersObject.KOTPRINTER
        })
      }
      }
      else if(this.state.forcePrinterSelection && chromePrintersObject.INVOICEPRINTER && (Array.isArray(chromePrintersObject.INVOICEPRINTER)) && chromePrintersObject.INVOICEPRINTER.length > 0)
      {
        if(chromePrintersObject.pageSize){
        jsonKOTBody = JSON.stringify({
          gngprint: message,
          KOTPRINTER: chromePrintersObject.INVOICEPRINTER,
          pageSize: chromePrintersObject.pageSize
        })
      }
      else{
        jsonKOTBody = JSON.stringify({
          gngprint: message,
          KOTPRINTER: chromePrintersObject.INVOICEPRINTER
        })
      }
      }
      else
      {
        jsonKOTBody = JSON.stringify({
          gngprint: message
        })
      }
      console.log("Json KOT body", jsonKOTBody);
      
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getPrinter(),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body:jsonKOTBody
          // body: JSON.stringify({
          //   gngprint: message
            
          // }),
        }
      );

      console.log("peri kot print", response);

      if (response.status !== 200) {
        if (response.status === 801){
          alert("printer Issue, Retry Print");  
        }
        else{
          alert("Printer Not Avaiable");
        }
      }
    } catch (error) {
      console.log("error", error);
      alert("Printer Not Avaiable");
    }
  };

  printInvoiceRest = async (message) => {
    try {
      var jsonInvoiceBody = "";
      
     // const chromePrintersObject = JSON.parse(this.state.chromePrinters);
      const chromePrintersObject = typeof this.state.chromePrinters === "string"
    ? JSON.parse(this.state.chromePrinters)
    : this.state.chromePrinters;
      
          // Check if pageSize exists
    
      if(this.state.forcePrinterSelection && chromePrintersObject.INVOICEPRINTER && (Array.isArray(chromePrintersObject.INVOICEPRINTER)) && chromePrintersObject.INVOICEPRINTER.length > 0)
      {
        if(chromePrintersObject.pageSize){
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INVOICEPRINTER: chromePrintersObject.INVOICEPRINTER,
            pageSize: chromePrintersObject.pageSize
          })
        }else{
        jsonInvoiceBody = JSON.stringify({
          gnginvoiceprint: message,
          INVOICEPRINTER: chromePrintersObject.INVOICEPRINTER
        })
      }
      }
      else if(this.state.forcePrinterSelection && chromePrintersObject.KOTPRINTER && (Array.isArray(chromePrintersObject.KOTPRINTER)) && chromePrintersObject.KOTPRINTER.length > 0)
        {
          if(chromePrintersObject.pageSize){
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INNOVICEPRINTER: chromePrintersObject.KOTPRINTER,
            pageSize: chromePrintersObject.pageSize
          })
        }else{
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message,
            INNOVICEPRINTER: chromePrintersObject.KOTPRINTER
          })
        }
        }
        else
        {
          jsonInvoiceBody = JSON.stringify({
            gnginvoiceprint: message
          })
        }
      console.log("Json Invoice body", jsonInvoiceBody);
      
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getPrinter(),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body:jsonInvoiceBody
          // body: JSON.stringify({
          //   gnginvoiceprint: message
            
          // }),
          
        }
      );

      console.log("print", response);

      if (response.status !== 200) {
        if (response.status === 801){
          alert("printer Issue, Retry Print");  
        }
        else{
          alert("Printer Not Avaiable");
        }
      }
    } catch (error) {
      console.log("error", error);
      alert("Printer Not Avaiable");
    }
  };
  getInvoiceDetails = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    let gngPrinterFontSize = localStorage.getItem("gngPrinterFontSize");

    let fontSize = 14;
    if (gngPrinterFontSize !== null) {
      fontSize = gngPrinterFontSize;
    }

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    console.log(
      "params",
      JSON.stringify({
        checkout_id: this.props.order.node.cart.checkout.id,
        font_size: fontSize,
        print_type: "INVOICE",
      })
    );
    // region_name
    try {
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/product/get_invoice_details_html_string/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            checkout_id: this.props.order.node.cart.checkout.id,
            font_size: fontSize,
            print_type: "INVOICE",
          }),
        }
      );

      console.log("INVOICE", response);

      if (response.status === 200) {
        let json = await response.json();
        let res = json.result;
        console.log("INVOICE", res);
        let invoice = "";
        if (res && res.length > 0) {
          invoice = `${res[0]}`;
        }

        this.setState({ invoicePrintFun: invoice });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  getOrderSummary = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
  
  
    // region_name
    try {
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/order/adlgetordersumary/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            order_id: this.props.order.node.orderId
          }),
        }
      );

     

      if (response.status === 200) {
        let json = await response.json();
        let res = json.order_summary;
        console.log("INVOICE", res);
        let order_summary = "";
        if (res ) {
          order_summary = `${res}`;
        }

        this.setState({ order_summary: order_summary });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  getKOTDetails = async () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;

    let gngPrinterFontSize = localStorage.getItem("gngPrinterFontSize");

    let fontSize = 14;
    if (gngPrinterFontSize !== null) {
      fontSize = gngPrinterFontSize;
    }

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Token " + authToken);
    console.log(
      "params",
      JSON.stringify({
        checkout_id: this.props.order.node.id,
        font_size: fontSize,
        print_type: "KOT",
      })
    );
    // region_name
    try {
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/product/get_invoice_details_html_string/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            checkout_id: this.props.order.node.id,
            font_size: fontSize,
            print_type: "KOT",
          }),
        }
      );

      console.log("KOT", response);

      if (response.status === 200) {
        let json = await response.json();
        let res = json.result;

        let kot = "";
        if (res && res.length > 0) {
          kot = `${res[0]}`;
        }
        console.log("KOT", res);
        this.setState({ printKOTFun: kot });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  goBackMain = () => {
    this.props.refreshOrders();
    this.props.goBack();
  };
  getPayment = () => {
    let total = this.props.order.node.cart.total;
    let payments = this.props.order.node.cart.checkout.payments.edges;
    let paid = false,
      paidText = "Payment Pending";
    for (let i = 0; i < payments.length; i++) {
      if (
        (payments[i].node.status === "SUCCESS" ||
          payments[i].node.status === "PROCESSED") 
          /*&&
        // eslint-disable-next-line
        parseInt(payments[i].node.amount) >= parseInt(total)
        */
      ) {
        paid = true;
      }
    }
    if (paid) {
      paidText = "PAID";
    }
    return paidText;
  };
  getPaymentBackgroudColor = () => {
    let total = this.props.order.node.cart.total;
    let payments = this.props.order.node.cart.checkout.payments.edges;
    let paid = false;
    for (let i = 0; i < payments.length; i++) {
      if (
        (payments[i].node.status === "SUCCESS" ||
          payments[i].node.status === "PROCESSED") &&
        // eslint-disable-next-line
        parseInt(payments[i].node.amount) >= parseInt(total)
      ) {
        paid = true;
      }
    }

    return paid;
  };

  getDeliverySlot = () => {
    console.log('Deliveryslot1', this.state.order.node.cart.settlementPrice)
    console.log('Deliveryslot2', this.state.order.node.cart)
    let deliverySlot = "";
    if (this.state.order.node.cart.deliverySlot !==null && this.state.order.node.cart.deliverySlot !== undefined){
    deliverySlot = "Delivery Slot: " + this.state.order.node.cart.deliverySlot
    }
    return deliverySlot;
  }
  getDeliveryLocation = () => {
    let deliveryLocation = "";
    let vehicleString = "";
    if (
      this.props.order.node.cart.checkout &&
      this.props.order.node.cart.checkout.mode !== null
    ) {
      vehicleString = this.props.order.node.cart.checkout.mode;
      if (vehicleString === "TABLE_SERVICE") {
        if (this.props.order.node.cart.checkout.deliveryLocation !== null) {
          deliveryLocation =
            "Table No:" + this.props.order.node.cart.checkout.deliveryLocation;
        }
      } else {
        if (this.props.order.node.cart.checkout.deliveryLocation !== null) {
          deliveryLocation =
            "Delivery Location: " +
            this.props.order.node.cart.checkout.deliveryLocation;
        }
      }
      
      if (deliveryLocation === "") {
        if (
          this.props.order.node.cart.checkout.userLocation &&
          this.props.order.node.cart.checkout.userLocation !== null
        ) {
          console.log('deliveryLocation', deliveryLocation)
          let house = ''
          let addressLine1 = ''
          let addressLine2 = ''
          let landmark = ''
          let pincode = ''
          let city = ''
          
          if(this.state.order.node.cart.checkout.userLocation.house !== null) { house = this.state.order.node.cart.checkout.userLocation.house }
          if(this.state.order.node.cart.checkout.userLocation.addressLine1 !== null) { addressLine1 = this.state.order.node.cart.checkout.userLocation.addressLine1 }  
          if(this.state.order.node.cart.checkout.userLocation.addressLine2 !== null) { addressLine2 = this.state.order.node.cart.checkout.userLocation.addressLine2 }  
          if(this.state.order.node.cart.checkout.userLocation.landmark !== null) { landmark = this.state.order.node.cart.checkout.userLocation.landmark }  
          if(this.state.order.node.cart.checkout.userLocation.pincode !== null) { pincode = this.state.order.node.cart.checkout.userLocation.pincode }  
          if(this.state.order.node.cart.checkout.userLocation.city !== null) { city = this.state.order.node.cart.checkout.userLocation.city }  
          
          deliveryLocation =
            'Address:'
            + ' ' + house
            + ' ' + addressLine1 
            + ' ' + addressLine2
            + ' ' + landmark
            + ' ' + pincode
            + ' ' + city
         
            
        }
      }
    }
    return deliveryLocation;
  };

  getGeoLocation = () => {
    
    if ('geolocation' in navigator) {
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if ('coords' in position) {
            
            const { latitude, longitude } = position.coords;
            console.log('Lat and lng', position.coords);
            // userLocation && setUserLocation(userlocations);
          }
        },
        
      );
    }
  };
  
  openGoogleMaps = () => {
    //getDirections(data);
    try{
    if ('geolocation' in navigator) {
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if ('coords' in position) {
            
            const { latitude, longitude } = position.coords;
            if (this.state.order.node.cart.checkout.userLocation.latitude !== null && this.state.order.node.cart.checkout.userLocation.latitude !== undefined ){
              let dest_lat = this.state.order.node.cart.checkout.userLocation.latitude
              let dest_lng = this.state.order.node.cart.checkout.userLocation.longitude
            window.open("https://www.google.com/maps/dir/"+latitude+","+longitude+"/"+dest_lat+","+dest_lng)
            }
            // userLocation && setUserLocation(userlocations);
          }
        },
        
      );
    }
  } catch (error) {
    console.log("error", error);
  }

    
  }


  getPaymentMode = () => {
    let mode = this.props.order.node.cart.checkout.payments.edges[0].node.mode;

    return mode;
  };
  getToken = () => {
    let token = JSON.stringify(this.state.order.node.storeToken);
    // if (token.length <= 4) {
    //   if (token.length === 1) {
    //     token = "000" + token;
    //   } else if (token.length === 2) {
    //     token = "00" + token;
    //   } else if (token.length === 3) {
    //     token = "0" + token;
    //   }
    // }
    return token;
  };

  renderDeliveredActionButton = () => {
    let loginMode = localStorage.getItem("loginMode");
    return this.props.order.node.status === "PUSHED" ||
      this.state.order.node.status === "DELIVERED" ||
      this.state.order.node.status === "DISPATCHED" ||
      this.state.order.node.status === "REJECTED" ||
      this.state.order.node.status === "NEW" ? null : (
      <Alert
        color={
          this.state.order.node.status === "ACCEPTED" ? "warning" : "success"
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            {this.state.order.node.status === "READY" ? (
              <h4>Item is ready</h4>
            ) : (
              <div>
                <h4>Time Remaining</h4>
                <Countdown
                  date={
                    loginMode === "merchant"
                      ? moment() + 0
                      : moment() + this.getCountDownTime()
                  }
                  renderer={rendererTimer}
                />
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Button
              color={
                this.state.order.node.status === "ACCEPTED"
                  ? "primary"
                  : "secondary"
              }
              disabled={
                this.state.order.node.status === "ACCEPTED" ? false : true
              }
              onClick={() => {
                this.updateOrderStatus("DELIVERED");
              }}
            >
              ORDER IS DELIVERED
            </Button>
          </div>
        </div>
      </Alert>
    );
  };

  renderReadyActionButton = () => {
    let loginMode = localStorage.getItem("loginMode");
    return this.props.order.node.status === "PUSHED" ||
      this.state.order.node.status === "DELIVERED" ||
      this.state.order.node.status === "DISPATCHED" ||
      this.state.order.node.status === "REJECTED" ||
      this.state.order.node.status === "NEW" ? null : (
      <Alert
        color={
          this.state.order.node.status === "ACCEPTED" ? "warning" : "success"
        }
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div>
            {this.state.order.node.status === "READY" ? (
              <h4>Item is ready</h4>
            ) : (
              <div>
                <h4>Time Remaining</h4>
                <Countdown
                  date={
                    loginMode === "merchant"
                      ? moment() + 0
                      : moment() + this.getCountDownTime()
                  }
                  renderer={rendererTimer}
                />
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Button
              color={
                this.state.order.node.status === "ACCEPTED"
                  ? "primary"
                  : "secondary"
              }
              disabled={
                this.state.order.node.status === "ACCEPTED" ? false : true
              }
              onClick={() => {
                this.updateOrderStatus("READY");
              }}
            >
              ORDER IS READY
            </Button>
          </div>
        </div>
      </Alert>
    );
  };
  getCountDownTime = () => {
    try {
    let readyTime, ms;
    if (this.props.order.node.deliveryEndtime != null){
          readyTime = moment(this.props.order.node.deliveryEndtime);
          ms =
          moment.duration(readyTime.diff(moment())).minutes() * 60 * 1000 +
          moment.duration(readyTime.diff(moment())).seconds() * 1000;
        }
    else if (this.props.order.node.deliveryEndtime == null && this.props.order.node.pushedAt !== null) {
      if (this.props.order.node.sla !== null)
        readyTime = moment(this.props.order.node.pushedAt).add(
          this.props.order.node.sla,
          "s"
        );
      else readyTime = moment(this.props.order.node.pushedAt).add(900, "s");

      ms =
        moment.duration(readyTime.diff(moment())).minutes() * 60 * 1000 +
        moment.duration(readyTime.diff(moment())).seconds() * 1000;
    } else {
      ms = 0;
    }
    return ms;
  } catch (error) {
    console.log("getCountDownTime detailedcard function", error);
    return 0;
}
  };

  getProductName = (cartItem) => {
    let name = cartItem.node.stock.referenceName;
    if (cartItem.node.stock.sku.quantity !== null) {
      name = name + " - " + cartItem.node.stock.sku.quantity;
    }
    if (cartItem.node.stock.sku.unit !== null) {
      name = name + " - " + cartItem.node.stock.sku.unit;
    }

    return name;
  };
  getLocalChinaProductName = (cartItem) => {
    let name = "";

    if (
      cartItem.node.stock.locallngName &&
      cartItem.node.stock.locallngName !== null &&
      cartItem.node.stock.locallngName !== ""
    ) {
      name = cartItem.node.stock.locallngName;
    }

    return name;
  };
  getItemPrice = (cartItem) => {
    let price = "",
      name = "";
    let pretaxprice = 0.0;
    console.log('cartItem', cartItem)
    if (this.state.order.node.cart.pickupPoint.store.taxIncluded !==null &&
    this.state.order.node.cart.pickupPoint.store.taxIncluded ===true){
      
      pretaxprice = (cartItem.node.settlementPrice/(1+(cartItem.node.stock.taxValue/100))).toFixed(2)
      console.log('pretaxprice-1', pretaxprice);
    }
    else{
      pretaxprice = cartItem.node.settlementPrice.toFixed(2)
      console.log('pretaxprice-2', pretaxprice);
    }
    if (
      cartItem.node.stock.locallngName &&
      cartItem.node.stock.locallngName !== null &&
      cartItem.node.stock.locallngName !== ""
    ) {
      name = cartItem.node.stock.locallngName;
    }
    price = "₹" + pretaxprice;
    // if (name === "") {
    //   price =
    //     "₹" +
    //     // cartItem.node.settlementPrice / cartItem.node.quantity +
    //    // pretaxprice/cartItem.node.quantity
    //    pretaxprice
    //     // " × " +
    //     // cartItem.node.quantity +
    //     // " = ₹" +
    //     // // cartItem.node.settlementPrice;
    //     // pretaxprice;
    // } else {
    //   price =
    //     "$" +
    //     pretaxprice
    //     // cartItem.node.settlementPrice / cartItem.node.quantity +
    //     // (pretaxprice/cartItem.node.quantity)
    //     // " × " +
    //     // cartItem.node.quantity +
    //     // " = $" +
    //     // // cartItem.node.settlementPrice;
    //     // pretaxprice;
    // }
    console.log('price',price)
    return price;
  };
  renderActionAcceptAndReject = () => {
    if (this.state.order.node.status === "PUSHED") {
      return (
        <div style={{ display: "flex", flex: 1 }}>
          {this.props.storeInformation.store &&
          this.props.storeInformation.store.canMarkAccept === true &&
          this.props.storeInformation.store &&
          this.props.storeInformation.store.canMarkReject === true ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              {
                // <div
                //   style={{
                //     backgroundColor: "red",
                //     marginRight: 10,
                //     paddingTop: 6,
                //   }}
                // >
                //   <a
                //     style={{ color: "white", padding: 10 }}
                //     onClick={() => {
                //       if (
                //         this.state.order &&
                //         this.state.order.node.comments !== null
                //       ) {
                //         this.updateOrderStatus("REJECTED");
                //       } else {
                //         this.toggleErrorLoginModal("Enter reason in comments ");
                //       }
                //     }}
                //   >
                //     REJECT
                //   </a>
                // </div>
              }
              <div style={{ backgroundColor: "green", paddingTop: 6 }}>
                {this.props.storeInformation.store &&
                this.props.storeInformation.store.isPrintEnabled === true &&
                this.props.storeInformation.store.printSdkType ===
                  SDK_NGX_NIX ? (
                  <a
                    href={this.state.printRef}
                    style={{ color: "white", padding: 16 }}
                    onClick={() => {
                      let requestManager = new RequestManager();
                      requestManager.getStoreDetails();
                      this.updateOrderStatus("ACCEPTED");
                    }}
                  >
                    Accept
                  </a>
                ) : (
                  <a
                    style={{ color: "white", padding: 16 }}
                    onClick={() => {
                      this.updateOrderStatus("ACCEPTED");
                    }}
                  >
                    Accept
                  </a>
                )}
              </div>
            </div>
          ) : (
            <div style={{ backgroundColor: "green", paddingTop: 6 }}>
              {this.props.storeInformation.store &&
              this.props.storeInformation.store.isPrintEnabled === true &&
              this.props.storeInformation.store.printSdkType === SDK_NGX_NIX ? (
                <a
                  href={this.state.printRef}
                  style={{ color: "white", padding: 16 }}
                  onClick={() => {
                    let requestManager = new RequestManager();
                    requestManager.getStoreDetails();
                    this.updateOrderStatus("ACCEPTED");
                  }}
                >
                  Accept
                </a>
              ) : (
                <a
                  style={{ color: "white", padding: 16 }}
                  onClick={() => {
                    this.updateOrderStatus("ACCEPTED");
                  }}
                >
                  Accept
                </a>
              )}
            </div>
          )}
        </div>
      );
    }
  };

  toggleErrorLoginModal = (text) => {
    this.setState({
      loginModalVisible: !this.state.loginModalVisible,
      loginErrorMessage: text,
    });
  };
  toggleConfirmPayatCounter = () => {
    this.setState({
      payAtCounterModalVisible: !this.state.payAtCounterModalVisible,
    });
    this.props.refreshOrders();
  };
  toggleOrderItemInactiveModal = () => {
    this.setState({
      itemInactiveVisible: !this.state.itemInactiveVisible,
    });
    this.fetchOrderDetails();
    this.props.refreshOrders();
  };

  printCount = (order) => {
    // Print Count per order
    let defaultLines = 16,
      cusLen = 0,
      AEPCount = 0,
      finalCount = 0;
    let productLen = order.node.cart.cartItems.edges.length;
    if (order !== null) {
      if (order.node.cart.checkout.codeType !== null) {
        if (this.props.order.node.cart.checkout.codeType === "AEP") {
          AEPCount = AEPCount + 1;
        }
      }

      for (let i = 0; i < order.node.cart.cartItems.edges.length; i++) {
        // console.log("print Order",JSON.stringify(order))
        let referenceNameLen =
          order.node.cart.cartItems.edges[i].node.stock.referenceName.length;

        if (referenceNameLen > 21) {
          productLen = productLen + 1;
        }
        cusLen =
          order.node.cart.cartItems.edges[i].node.customizations.edges.length;
        for (
          let j = 0;
          j <
          order.node.cart.cartItems.edges[i].node.customizations.edges.length;
          j++
        ) {
          let cname =
            order.node.cart.cartItems.edges[i].node.customizations.edges[j].node
              .name;

          let parent =
            order.node.cart.cartItems.edges[i].node.customizations.edges[j].node
              .parent.name;

          if ((parent + ":" + cname).length > 21) {
            cusLen = cusLen + 1;
          }
        }
      }
      if (cusLen > 0) {
        cusLen = cusLen + 1;
      }

      finalCount = defaultLines + productLen + cusLen + AEPCount;

      return finalCount;
    } else {
      return finalCount;
    }
  };

  updateSupportCommentsOrder = async () => {
    let requestManager = new RequestManager();
    let comments = "";
    if (this.state.order && this.state.order.node.comments != null) {
      comments = this.state.order.node.comments;
    }
    let params = {
      input: {
        id: this.props.order.node.id,
        comments:
          comments +
          this.props.storeInformation.store.name +
          ": " +
          this.rejectText,
      },
    };
    console.log("params11", JSON.stringify(params));
    let response = requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );

    this.rejectText = "";
    console.log("updateOrder Bill number", JSON.stringify(response));

    this.fetchOrderDetails();
  };

  updateorderstatusdb = async (status) =>{
    try {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      let authToken = storeInformation.token;
      var vtimestamp = generateEpochTimestamp();
      let response = await fetch(
        config.getHost() + "/order/updateorderstatus/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)                
          },
          body: JSON.stringify({
            id: this.state.order.node.id,
            status:status,
            graphql:true
          }),
        }
      );

      console.log("Response updateorderstatusdb", response);

      if (response.status === 200) {
        this.props.refreshOrders();
      } else {
        console.log("res updateorderstatusdb ", response.status);
      }
    } catch (error) {
      console.log("updateorderstatusdb function", error);
  }
};

  updateOrderStatus = async (status) => {
    // print count and barcodegenrate
    let printCount = 0;
    if (
      this.props.storeInformation.store &&
      this.props.storeInformation.store.isPrintEnabled &&
      this.props.storeInformation.store.isPrintEnabled === true
    ) {
      if (status === "ACCEPTED") {
        // Print KOT on Accepted Status
        if (
          this.props.storeInformation.store.printSdkType === SDK_NGX_ASHWA ||
          this.props.storeInformation.store.printSdkType === SDK_SUNMI_PRO2 ||
          this.props.storeInformation.store.printSdkType ===
            SDK_SUNMI_MINI_T1 ||
          this.props.storeInformation.store.printSdkType === SDK_NGX_NIX ||
          this.props.storeInformation.store.printSdkType === SDK_CHROME_ELECTRON
        ) {
          printCount = this.state.printRollCount;
          let order = this.state.order;
          let gngPrintersSelected = localStorage.getItem("gngPrintersSelected");

          let gngPrinterFontSize = localStorage.getItem("gngPrinterFontSize");

          let fontSize = 14;
          if (gngPrinterFontSize !== null) {
            fontSize = gngPrinterFontSize;
          }
          if (
            this.props.storeInformation.store &&
            this.props.storeInformation.store.barCodeGenerate === true
          ) {
            let obj = {
              BarCodeGenerate: "Y",
            };
            order.BarCodeGenerate = obj;

            order.DuplicatePrint = { DuplicatePrint: "N" };

            order.gngPrintersSelected = gngPrintersSelected;
          } else {
            let obj = {
              BarCodeGenerate: "N",
            };
            order.BarCodeGenerate = obj;
            order.DuplicatePrint = { DuplicatePrint: "N" };
            order.gngPrintersSelected = gngPrintersSelected;
          }

          if (
            this.props.storeInformation.store &&
            this.props.storeInformation.store.isPrintStoreName === true
          ) {
            order.isPrintStoreName = "Y";
          } else {
            order.isPrintStoreName = "N";
          }

          if (
            this.props.storeInformation.store &&
            this.props.storeInformation.store.isPrintRegionName === true
          ) {
            order.isPrintRegionName = "Y";
          } else {
            order.isPrintRegionName = "N";
          }

          if (
            this.props.storeInformation.store &&
            this.props.storeInformation.store.isPrintCustomerName === true
          ) {
            order.isPrintCustomerName = "Y";
          }

          if (
            this.props.storeInformation.store &&
            this.props.storeInformation.store.isPrintPickupPointName === true
          ) {
            order.isPrintPickupPointName = "Y";
          } else {
            order.isPrintPickupPointName = "N";
          }

          if (
            this.props.storeInformation.store &&
            this.props.storeInformation.store.isPrintCustomerPhoneNumber ===
              true
          ) {
            order.isPrintCustomerPhoneNumber = "Y";
          } else {
            order.isPrintCustomerPhoneNumber = "N";
          }

          order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
          order.fontSize = fontSize;
          order.printKOTFun = this.state.printKOTFun;
          // this Console is important to print KOT Electron app
          // console.log(JSON.stringify({ gngprintText: order }));
          // await this.printRest(this.state.printKOTFun);
          // console.log('peri after kot print');

          // printed for Mumbai and Bangalore airport
          if (
            (this.props.storeInformation.store &&
              this.props.storeInformation.store.printSdkType ===
                SDK_NGX_ASHWA) ||
            this.props.storeInformation.store.printSdkType === SDK_SUNMI_PRO2 ||
            this.props.storeInformation.store.printSdkType === SDK_SUNMI_MINI_T1
          ) {
            this.fromAndroid(order);
          }

          if (
            this.props.storeInformation.store.isMultiplePrintEnabled &&
            this.props.storeInformation.store.isMultiplePrintEnabled === true
          ) {
            let printedOrders = localStorage.getItem("printedOrders");
            let print = JSON.parse(printedOrders);
            localStorage.setItem(
              "printedOrders",
              JSON.stringify({
                orders: print.orders.concat(this.props.order.node.orderId),
              })
            );
          }
        }
      }
    }
    if (status === "DELIVERED" || status === "DISPATCHED") {
      let storageData = localStorage.getItem("attendedOrders");
      let attendedOrders;
      if (storageData === null) {
        attendedOrders = {
          newOrders: [],
          arrivedOrders: [],
          approachingOrders: [],
        };
      } else {
        attendedOrders = JSON.parse(storageData);
      }

      let check = false;

      for (let i = 0; i < attendedOrders.newOrders.length; i++) {
        if (attendedOrders.newOrders[i] === this.props.order.node.orderId) {
          console.log("attendedOrders removed", attendedOrders.newOrders[i]);
          attendedOrders.newOrders.splice(i, 1);
          check = true;
          break;
        }
      }

      if (check === true) {
        localStorage.setItem(
          "attendedOrders",
          JSON.stringify({
            newOrders: attendedOrders.newOrders,
            approachingOrders: attendedOrders.approachingOrders,
            arrivedOrders: attendedOrders.arrivedOrders,
          })
        );
      }
    }
    let oupdate_response = await orderStatusManager.updateOrderStatus(
      this.state.order.node.id,
      status,
      printCount,
      this.props.refreshOrders
    );
    if (oupdate_response === false)
    {
    try{
    await this.updateorderstatusdb(status);
    }catch(error){
      console.log("error updateorderstatusdb",error );
    }
  }
    // alert(JSON.stringify(check) )
    this.props.refreshOrders();

    if (status === "ACCEPTED") {
      // Print KOT on Accepted Status
      if (
        this.props.storeInformation.store.printSdkType === SDK_NGX_ASHWA ||
        this.props.storeInformation.store.printSdkType === SDK_SUNMI_PRO2 ||
        this.props.storeInformation.store.printSdkType ===
          SDK_SUNMI_MINI_T1 ||
        this.props.storeInformation.store.printSdkType === SDK_NGX_NIX ||
        this.props.storeInformation.store.printSdkType === SDK_CHROME_ELECTRON
      ) {
        this.printRest(this.state.printKOTFun);
        console.log('peri after kot print');
      }
    }
   

    this.props.goBack();

    // if(this.props.order.node.user.userProfile.codeType !== null &&
    //   this.props.order.node.user.userProfile.codeType === 'AEP' &&
    //   this.props.order.node.user.userProfile.codeVerified === false){}
  };

  renderPrintButton = () => {
    let printSdkType = "";
    if (
      this.props.storeInformation &&
      this.props.storeInformation.store &&
      this.props.storeInformation.store !== null
    )
      printSdkType = this.props.storeInformation.store.printSdkType;
    printSdkType = SDK_CHROME_ELECTRON;
    switch (printSdkType) {
      case SDK_NGX_NIX:
        // Delhi Print
        return (
          <div style={{ backgroundColor: "#00a9db", paddingTop: 6 }}>
            <a
              style={{
                color: "white",
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 10,
                paddingBottom: 10,
              }}
              href={this.state.printRef}
              onClick={() => {
                orderStatusManager.updateOrderStatus(
                  this.state.order.node.id,
                  "",
                  this.state.printRollCount,
                  this.props.refreshOrders
                );
                let requestManager = new RequestManager();
                requestManager.getStoreDetails();
              }}
            >
              RePrintKOT
            </a>
          </div>
        );

      case SDK_NGX_ASHWA:
        // Print Mumbai
        return (
          <Row style={{ marginLeft: 10 }}>
            <div style={{ backgroundColor: "#00a9db", paddingTop: 6 }}>
              <a
                style={{
                  color: "white",
                  paddingLeft: 8,
                  paddingRight: 8,
                  paddingTop: 10,
                  paddingBottom: 10,
                }}
                onClick={() => {
                  let order = this.state.order;
                  if (
                    this.props.storeInformation.store &&
                    this.props.storeInformation.store.barCodeGenerate === true
                  ) {
                    let obj = {
                      BarCodeGenerate: "Y",
                    };
                    order.BarCodeGenerate = obj;
                    order.DuplicatePrint = { DuplicatePrint: "Y" };
                  } else {
                    let obj = {
                      BarCodeGenerate: "N",
                    };
                    order.BarCodeGenerate = obj;
                    order.DuplicatePrint = { DuplicatePrint: "Y" };
                  }
                  if (
                    this.props.storeInformation.store &&
                    this.props.storeInformation.store.isPrintStoreName === true
                  ) {
                    order.isPrintStoreName = "Y";
                  } else {
                    order.isPrintStoreName = "N";
                  }

                  if (
                    this.props.storeInformation.store &&
                    this.props.storeInformation.store.isPrintRegionName === true
                  ) {
                    order.isPrintRegionName = "Y";
                  } else {
                    order.isPrintRegionName = "N";
                  }

                  if (
                    this.props.storeInformation.store &&
                    this.props.storeInformation.store.isPrintCustomerName ===
                      true
                  ) {
                    order.isPrintCustomerName = "Y";
                  }

                  if (
                    this.props.storeInformation.store &&
                    this.props.storeInformation.store.isPrintPickupPointName ===
                      true
                  ) {
                    order.isPrintPickupPointName = "Y";
                  } else {
                    order.isPrintPickupPointName = "N";
                  }

                  if (
                    this.props.storeInformation.store &&
                    this.props.storeInformation.store
                      .isPrintCustomerPhoneNumber === true
                  ) {
                    order.isPrintCustomerPhoneNumber = "Y";
                  } else {
                    order.isPrintCustomerPhoneNumber = "N";
                  }
                  order.isPrintReciept = "N";
                  order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
                  this.fromAndroid(order);
                }}
              >
                RePrintKOT
              </a>
            </div>
            {
              // <div
              //   style={{
              //     backgroundColor: "#00a9db",
              //     paddingTop: 6,
              //     marginLeft: 12,
              //     marginRight: 12,
              //   }}
              // >
              //   <a
              //     style={{
              //       color: "white",
              //       paddingLeft: 8,
              //       paddingRight: 8,
              //       paddingTop: 10,
              //       paddingBottom: 10,
              //     }}
              //     onClick={() => {
              //       let order = this.state.order;
              //       let obj = {
              //         BarCodeGenerate: "N",
              //       };
              //       order.BarCodeGenerate = obj;
              //       order.DuplicatePrint = { DuplicatePrint: "N" };
              //       order.isPrintStoreName = "Y";
              //       order.isPrintRegionName = "Y";
              //       order.isPrintCustomerName = "Y";
              //       order.isPrintPickupPointName = "Y";
              //       order.isPrintCustomerPhoneNumber = "N";
              //       order.isPrintReciept = "Y";
              //       order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
              //       this.fromAndroid(order);
              //     }}
              //   >
              //     PrintReciept
              //   </a>
              // </div>
            }
          </Row>
        );
      case SDK_SUNMI_PRO2:
        // Print Mumbai
        return (
          <div style={{ backgroundColor: "#00a9db", paddingTop: 6 }}>
            <a
              style={{
                color: "white",
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 10,
                paddingBottom: 10,
              }}
              onClick={() => {
                let order = this.state.order;
                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.barCodeGenerate === true
                ) {
                  let obj = {
                    BarCodeGenerate: "Y",
                  };
                  order.BarCodeGenerate = obj;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                } else {
                  let obj = {
                    BarCodeGenerate: "N",
                  };
                  order.BarCodeGenerate = obj;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                }
                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintStoreName === true
                ) {
                  order.isPrintStoreName = "Y";
                } else {
                  order.isPrintStoreName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintRegionName === true
                ) {
                  order.isPrintRegionName = "Y";
                } else {
                  order.isPrintRegionName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintCustomerName === true
                ) {
                  order.isPrintCustomerName = "Y";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintPickupPointName ===
                    true
                ) {
                  order.isPrintPickupPointName = "Y";
                } else {
                  order.isPrintPickupPointName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store
                    .isPrintCustomerPhoneNumber === true
                ) {
                  order.isPrintCustomerPhoneNumber = "Y";
                } else {
                  order.isPrintCustomerPhoneNumber = "N";
                }
                order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
                this.fromAndroid(order);
              }}
            >
              RePrintKOT
            </a>
          </div>
        );
      case SDK_SUNMI_MINI_T1:
        // Print Mumbai
        return (
          <div style={{ backgroundColor: "#00a9db", paddingTop: 6 }}>
            <a
              style={{
                color: "white",
                paddingLeft: 8,
                paddingRight: 8,
                paddingTop: 10,
                paddingBottom: 10,
              }}
              onClick={() => {
                let order = this.state.order;
                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.barCodeGenerate === true
                ) {
                  let obj = {
                    BarCodeGenerate: "Y",
                  };
                  order.BarCodeGenerate = obj;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                } else {
                  let obj = {
                    BarCodeGenerate: "N",
                  };
                  order.BarCodeGenerate = obj;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                }
                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintStoreName === true
                ) {
                  order.isPrintStoreName = "Y";
                } else {
                  order.isPrintStoreName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintRegionName === true
                ) {
                  order.isPrintRegionName = "Y";
                } else {
                  order.isPrintRegionName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintCustomerName === true
                ) {
                  order.isPrintCustomerName = "Y";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintPickupPointName ===
                    true
                ) {
                  order.isPrintPickupPointName = "Y";
                } else {
                  order.isPrintPickupPointName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store
                    .isPrintCustomerPhoneNumber === true
                ) {
                  order.isPrintCustomerPhoneNumber = "Y";
                } else {
                  order.isPrintCustomerPhoneNumber = "N";
                }
                order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
                this.fromAndroid(order);
              }}
            >
              RePrintKOT
            </a>
          </div>
        );
      case SDK_CHROME:
        return (
          <Row>
            <ReactToPrint
              trigger={() => (
                <Button color="primary" href="#">
                  RePrintKOT
                </Button>
              )}
              content={() => this.printDiv}
            />
          </Row>
        );

      case SDK_CHROME_ELECTRON:
        return (
          <Row>
            
            {/* {this.state.order.node.status !== 'DELIVERED' && this.state.order.node.status !== 'REJECTED' */}
            {this.state.order.node.status !== 'TESTDELIVERED' && this.state.order.node.status !== 'TESTREJECTED'
            &&(
              
            <Button
              color={"primary"}
              style={{ marginLeft: 10, marginRight: 10 }}
              onClick={() => {
                let order = this.state.order;
                let gngPrintersSelected = localStorage.getItem(
                  "gngPrintersSelected"
                );
                let gngPrinterFontSize = localStorage.getItem(
                  "gngPrinterFontSize"
                );

                let fontSize = 14;
                if (gngPrinterFontSize !== null) {
                  fontSize = gngPrinterFontSize;
                }
                console.log("fontSize", fontSize);

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.barCodeGenerate === true
                ) {
                  let obj = {
                    BarCodeGenerate: "Y",
                  };
                  order.BarCodeGenerate = obj;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                  order.gngPrintersSelected = gngPrintersSelected;
                } else {
                  let obj = {
                    BarCodeGenerate: "N",
                  };
                  order.BarCodeGenerate = obj;
                  order.gngPrintersSelected = gngPrintersSelected;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintStoreName === true
                ) {
                  order.isPrintStoreName = "Y";
                } else {
                  order.isPrintStoreName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintRegionName === true
                ) {
                  order.isPrintRegionName = "Y";
                } else {
                  order.isPrintRegionName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintCustomerName === true
                ) {
                  order.isPrintCustomerName = "Y";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintPickupPointName ===
                    true
                ) {
                  order.isPrintPickupPointName = "Y";
                } else {
                  order.isPrintPickupPointName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store
                    .isPrintCustomerPhoneNumber === true
                ) {
                  order.isPrintCustomerPhoneNumber = "Y";
                } else {
                  order.isPrintCustomerPhoneNumber = "N";
                }
                order.currentDate = moment().format("DD/MM/YYYY, h:mm a");

                // `<p>Thanks for ordering with GrabbnGo.
                // receipt for order on 2020-06-25 12:12:02.373657+00</p><p>HMSHOST SERVICES INDIA PVT LTD
                //         GSTIN No.: 29AABCH7805C1ZR
                //          Place: BLR Airport</p><p>TASTE OF INDIA
                // GNG20200623446071068.90</p><table style="width: 100%;"><tbody><tr><td style="width: 60%;">Item</td><td style="width: 15%;">QTY</td><td style="width: 15%;">AMT</td></tr><tr><td style="width: 60%;">Chicken Tikka</td><td style="width: 15%;">1</td><td style="width: 15%;">469.00</td></tr><tr><td style="width: 60%;">Chicken Dum Biryani</td><td style="width: 15%;">1</td><td style="width: 15%;">549.00</td></tr><tr><td style="width: 60%;">2.5% CGST</td><td style="width: 15%;"></td><td style="width: 15%;">25.45</td></tr><tr><td style="width: 60%;">2.5% SGST</td><td style="width: 15%;"></td><td style="width: 15%;">25.45</td></tr><tr><td style="width: 60%;">Total</td><td style="width: 15%;"></td><td style="width: 15%;">1068.90</td></tr></tbody></table>`;
                order.fontSize = fontSize;
                order.printKOTFun = this.state.printKOTFun;
                // console.log(JSON.stringify({ gngprintText: order }));
                this.printRest(this.state.printKOTFun);
                // peri new printer module
              }}
            >
              RePrintKOT
            </Button>
            )}
            {/* {this.props.order.node.status != 'DELIVERED' && this.props.order.node.status != 'REJECTED'&&(  */}
            {this.props.order.node.status != 'TESTDELIVERED' && this.props.order.node.status != 'TESTREJECTED'&&(   
            <Button
              color={"primary"}
              style={{ marginLeft: 10, marginRight: 10 }}
              onClick={() => {
                let order = this.state.order;
                let gngPrintersSelected = localStorage.getItem(
                  "gngPrintersSelected"
                );
                let gngPrinterFontSize = localStorage.getItem(
                  "gngPrinterFontSize"
                );

                let fontSize = 14;
                if (gngPrinterFontSize !== null) {
                  fontSize = gngPrinterFontSize;
                }
                console.log("fontSize", fontSize);

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.barCodeGenerate === true
                ) {
                  let obj = {
                    BarCodeGenerate: "Y",
                  };
                  order.BarCodeGenerate = obj;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                  order.gngPrintersSelected = gngPrintersSelected;
                } else {
                  let obj = {
                    BarCodeGenerate: "N",
                  };
                  order.BarCodeGenerate = obj;
                  order.gngPrintersSelected = gngPrintersSelected;
                  order.DuplicatePrint = { DuplicatePrint: "Y" };
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintStoreName === true
                ) {
                  order.isPrintStoreName = "Y";
                } else {
                  order.isPrintStoreName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintRegionName === true
                ) {
                  order.isPrintRegionName = "Y";
                } else {
                  order.isPrintRegionName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintCustomerName === true
                ) {
                  order.isPrintCustomerName = "Y";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store.isPrintPickupPointName ===
                    true
                ) {
                  order.isPrintPickupPointName = "Y";
                } else {
                  order.isPrintPickupPointName = "N";
                }

                if (
                  this.props.storeInformation.store &&
                  this.props.storeInformation.store
                    .isPrintCustomerPhoneNumber === true
                ) {
                  order.isPrintCustomerPhoneNumber = "Y";
                } else {
                  order.isPrintCustomerPhoneNumber = "N";
                }
                order.currentDate = moment().format("DD/MM/YYYY, h:mm a");

                // `<p>Thanks for ordering with GrabbnGo.
                // receipt for order on 2020-06-25 12:12:02.373657+00</p><p>HMSHOST SERVICES INDIA PVT LTD
                //         GSTIN No.: 29AABCH7805C1ZR
                //          Place: BLR Airport</p><p>TASTE OF INDIA
                // GNG20200623446071068.90</p><table style="width: 100%;"><tbody><tr><td style="width: 60%;">Item</td><td style="width: 15%;">QTY</td><td style="width: 15%;">AMT</td></tr><tr><td style="width: 60%;">Chicken Tikka</td><td style="width: 15%;">1</td><td style="width: 15%;">469.00</td></tr><tr><td style="width: 60%;">Chicken Dum Biryani</td><td style="width: 15%;">1</td><td style="width: 15%;">549.00</td></tr><tr><td style="width: 60%;">2.5% CGST</td><td style="width: 15%;"></td><td style="width: 15%;">25.45</td></tr><tr><td style="width: 60%;">2.5% SGST</td><td style="width: 15%;"></td><td style="width: 15%;">25.45</td></tr><tr><td style="width: 60%;">Total</td><td style="width: 15%;"></td><td style="width: 15%;">1068.90</td></tr></tbody></table>`;
                order.fontSize = fontSize;
                order.printKOTFun = this.state.printKOTFun;
                // console.log(JSON.stringify({ gngprintText: order }));
                this.printInvoiceRest(this.state.printKOTFun);
                // peri new printer module
              }}
            >
              Billing Station KOT
            </Button>
)  }
  {/* {this.state.order.node.status !== 'REJECTED' &&( */}
    {this.state.order.node.status !== 'TESTREJECTED' &&(
            <Button
              color={"primary"}
              editable={true}
              onClick={() => {
                let order = this.state.order;
                let gngPrintersSelected = localStorage.getItem(
                  "gngPrintersSelected"
                );

                let gngPrinterFontSize = localStorage.getItem(
                  "gngPrinterFontSize"
                );
                let fontSize = 14;
                if (gngPrinterFontSize !== null) {
                  fontSize = gngPrinterFontSize;
                }
                console.log("fontSize", fontSize);

                let obj = {
                  BarCodeGenerate: "N",
                };
                order.BarCodeGenerate = obj;
                order.gngPrintersSelected = gngPrintersSelected;
                order.DuplicatePrint = { DuplicatePrint: "N" };
                order.isPrintStoreName = "Y";
                order.isPrintRegionName = "Y";
                order.isPrintCustomerName = "Y";
                order.isPrintPickupPointName = "Y";
                order.isPrintCustomerPhoneNumber = "N";

                order.currentDate = moment().format("DD/MM/YYYY, h:mm a");
                // function invoicePrint
                order.invoicePrint = this.state.invoicePrint;
                order.fontSize = fontSize;
                order.invoicePrintFun = this.state.invoicePrintFun;
                // console.log(JSON.stringify({ gngInvoicePrint: order }));
                this.printInvoiceRest(this.state.invoicePrintFun);
                // peri new printer module
              }}
            >
              Customer Receipt
            </Button>
  )}
          </Row>
        );

      default:
        return null;
    }
  };

  renderActionButtons = () => {
    if (this.props.editable) {
      switch (this.state.order.node.status) {
        // Mandatory for ready status
        // added reject for New Status
        case "NEW":
          return (
            <Row>
              {this.props.storeInformation.store &&
              this.props.storeInformation.store.canMarkReject === true ? (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "red",
                    margin: 10,
                  }}
                  onClick={() => {
                    this.toggleCommentsModal();
                    // if (
                    //   this.state.order &&
                    //   this.state.order.node.comments !== null
                    // ) {
                    //   this.updateOrderStatus("REJECTED");
                    // } else {
                    //   this.toggleErrorLoginModal("Enter reason in comments ");
                    // }
                  }}
                >
                  Reject
                </Button>
              ) : null}

              {this.props.storeInformation.store.canMarkRejectRequest &&
              this.props.storeInformation.store.canMarkRejectRequest ===
                true ? (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "green",
                    margin: 10,
                  }}
                  onClick={() => {
                    if (
                      this.state.order &&
                      this.state.order.node.comments !== null
                    ) {
                      orderStatusManager.updateOrderStatus(
                        this.state.order.node.id,
                        "REJECTREQUEST",
                        this.state.printRollCount,
                        this.props.refreshOrders
                        );
                      this.props.refreshOrders();
                      this.props.goBack();
                    } else {
                      this.toggleErrorLoginModal("Enter reason in comments ");
                    }
                  }}
                >
                  Reject Request
                </Button>
              ) : null}
            </Row>
          );          
        case "PUSHED":
          return (
            <Row>
              {this.props.storeInformation.store &&
              this.props.storeInformation.store.canMarkReject === true ? (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "red",
                    margin: 10,
                  }}
                  onClick={() => {
                    
                    this.toggleCommentsModal();
                    // if (
                    //   this.state.order &&
                    //   this.state.order.node.comments !== null
                    // ) {
                    //   this.updateOrderStatus("REJECTED");
                    // } else {
                    //   this.toggleErrorLoginModal("Enter reason in comments ");
                    // }
                  }}
                >
                  Reject
                </Button>
              ) : null}

              {this.props.storeInformation.store.canMarkRejectRequest &&
              this.props.storeInformation.store.canMarkRejectRequest ===
                true ? (
                <Button
                  style={{
                    color: "white",
                    backgroundColor: "green",
                    margin: 10,
                  }}
                  onClick={() => {
                    if (
                      this.state.order &&
                      this.state.order.node.comments !== null
                    ) {
                      orderStatusManager.updateOrderStatus(
                        this.state.order.node.id,
                        "REJECTREQUEST",
                        this.state.printRollCount,
                        this.props.refreshOrders
                      );
                      this.props.refreshOrders();
                      this.props.goBack();
                    } else {
                      this.toggleErrorLoginModal("Enter reason in comments ");
                    }
                  }}
                >
                  Reject Request
                </Button>
              ) : null}
            </Row>
          );
        case "REJECTREQUEST":
          return (
            <div>
              {this.props.storeInformation.store.canMarkRejectRequest &&
              this.props.storeInformation.store.canMarkRejectRequest ===
                true ? (
                <div style={{ backgroundColor: "green", padding: 6 }}>
                  <a
                    style={{ color: "white", padding: 16 }}
                    onClick={() => {
                      this.updateCancelRequest(
                        this.state.order.node.id,
                        "ACCEPTED",
                        0
                      );
                    }}
                  >
                    Accept
                  </a>
                </div>
              ) : null}
            </div>
          );
        case "DELIVERED":
          return (
            <div>
              {this.props.storeInformation.store &&
              this.props.storeInformation.store.canMarkDeliver === true ? (
                <div style={{ backgroundColor: "green" }}>
                  <a
                    style={{ color: "white", padding: 10 }}
                    onClick={() => {
                      if (this.getPayment() === "PAID") {
                        orderStatusManager.updateOrderStatus(
                          this.state.order.node.id,
                          "DELIVERED",
                          this.state.printRollCount,
                          this.props.refreshOrders
                        );
                        this.props.refreshOrders();
                        this.props.goBack();
                      } else {
                        this.toggleErrorLoginModal(
                          "Payment is pending, please make sure payment done."
                        );
                      }
                    }}
                  >
                    DELIVERED
                  </a>
                </div>
              ) : null}
            </div>
          );

          case "READY":
            return (
              <div>
                {this.props.storeInformation.store &&
                this.props.storeInformation.store.canMarkDeliver === true ? (
                  <div style={{ backgroundColor: "green", padding: 6 }}>
                    <a
                      style={{ color: "white" }}
                      onClick={() => {
                        if (this.getPayment() === "PAID") {
                          if (
                            this.props.order.node.cart.checkout.mode ===
                              "DELIVERY" 
                              ||
                            this.props.order.node.cart.checkout.mode ===
                              "SEAT_SERVICE"
                          ) {
                            
                            console.log("I AM IN Pending dispatched - ",this.props.order.node.cart.checkout.mode);
                            console.log("I AM IN Pending dispatched orderid- ",this.state.order.node.id);
                            orderStatusManager.updateOrderStatus(
                              this.state.order.node.id,
                              "PENDINGDISPATCHED",
                              this.state.printRollCount,
                              this.props.refreshOrders
                            );
                              console.log("Ready case - Pending dispatched");
                              this.updateOrderStatus("PENDINGDISPATCHED");
                          } else {
                            
                            console.log("I AM IN DELIVERED - ",this.props.order.node.cart.checkout.mode);
                            this.updateOrderStatus("DELIVERED");
                            console.log("Ready case - Delivered");
                          }
                        } else {
                          this.toggleErrorLoginModal(
                            "Payment is pending, please make sure payment done."
                          );
                        }
                      }}
                    >
                      Completed
                    </a>
                  </div>
                ) : null}
              </div>
            
          );

        default:
          return <div></div>;
      }
    } else {
      return null;
    }
  };

  updateCancelRequest = (orderId, status, printCount) => {
    let requestManager = new RequestManager();
    let params;

    params = {
      input: {
        id: orderId,
        status: status,
      },
    };

    console.log("orderId", JSON.stringify(params));
    let response = requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );
    console.log("updateOrder", JSON.stringify(response));
    if (response.error === null) {
      this.props.refreshOrders();
      this.props.goBack();
    } else {
      this.props.refreshOrders();
      this.props.goBack();
      //  alert("Something went wrong")
    }
  };
  renderCustomizations = (extraText) => {};
  renderAdditionalCharges = (extraText, item) => {
 
    console.log('ExtraText',extraText )
    //let extra = JSON.parse(extraText);
      let extra;
 try{
        if (typeof extraText === "string") {
          extra = JSON.parse(extraText);
        } else {
          extra = extraText;  // already parsed
        }
  } catch(error) {
          console.log("renderAdditionalCharges error", error);
  }
    let offers = extra.offer === null ? [] : extra.offer;
    let charges = extra.charge === null ? [] : extra.charge;
    return (
      <div style={{}}>
        {charges &&
          charges.map((charge, index) => {
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <p>{charge.label}</p>
                {this.getLocalChinaProductName(item) === "" ? (
                  <p>{"₹" + charge.amount}</p>
                ) : (
                  <p>{"$" + charge.amount}</p>
                )}
              </div>
            );
          })}
        {offers &&
          offers.map((offer, index) => {
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <p>{offer.label}</p>

                {this.getLocalChinaProductName(item) === "" ? (
                  <p>{"₹" + offer.amount}</p>
                ) : (
                  <p>{"$" + offer.amount}</p>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  updatePayCounter = async (orderId) => {
    let requestManager = new RequestManager();
    let params = {
      input: {
        id: orderId,
        isCompleted: true,
      },
    };

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updatePayCounter",
      params
    );
    console.log("updatePayCounter", JSON.stringify(response));
    if (response.error === null) {
      this.toggleErrorLoginModal("Succefully updated.");
      this.props.refreshOrders();
    } else {
      alert("Unable to update. Please check your internet connection.");
    }
  };

  toggleFullFilled = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let params = {
      input: {
        id: this.state.orderId,
        status: "UNFULFILLED",
      },
    };

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateFulfillment",
      params
    );
    if (response.error === null) {
      for (
        let i = 0;
        i < this.state.order.node.cart.cartItems.edges.length;
        i++
      ) {
        if (
          this.state.order.node.cart.cartItems.edges[i].node.id ===
          this.state.orderId
        ) {
          this.state.order.node.cart.cartItems.edges[i].node.status =
            "UNFULFILLED";
        }
      }
      this.setState({ spinnerLoading: false });
    } else {
      this.setState({ spinnerLoading: false });
      alert("Unable to update. Please check your internet connection.");
    }
  };

  fetchOrderDetails = async () => {
    console.log("Inside node id", this.props.order);
    console.log("Inside node id", this.props.order.node.cart);
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let params = {
      orderId: this.props.order.node.orderId,
    
    };
    console.log("fetchOrderDetails", params);

    // let response = await requestManager.getResponseFromPredefinedQuery(
    //   "getOrderDetails",
    //   params
    // );

      let storeInformation = JSON.parse(localStorage.getItem('storeInformation'));
        let authToken = storeInformation.token   
        var vtimestamp = generateEpochTimestamp();
        
      let   response = await fetch(config.getHost() + "/order/getorderdetails/", {
            method: "POST",
            headers: {
                Authorization: `Token ${authToken}`,
                'Content-Type': 'application/json',
                Timestamp: vtimestamp,
                Signature: generateSignature(vtimestamp, authToken)
              },
            body: JSON.stringify({
               order_id: this.props.order.node.orderId,
            }),    
        });
        let jsonres = {};
        if (response.status === 200){
          let jsonres = await response.json();
         // console.log('pastorders', jsonres)
        //&& jsonres.edges.length > 0
        if (jsonres && jsonres !== null ) {
    //Sunil Code - set chromePrinters and fetchPrinterInfo
    //this.state.chromePrinters=response.data.userProfile.user.store.chromePrinters;
    //this.state.fetchPrinterInfo=response.data.userProfile.store.fetchPrinterInfo;

    //if (response.error === null) {
      let order = jsonres.data.orderDetails.edges[0];
      
      console.log("order-santosh", JSON.stringify(order));
      console.log("Response data", order.node.cart.pickupPoint.store.chromePrinters);

      //Sunil Code - check chromPrinters if yes set the same
      if(order.node.cart.pickupPoint.store.chromePrinters)
      {
        this.setState({chromePrinters:order.node.cart.pickupPoint.store.chromePrinters});
      }
      try{
      if(order.node.cart.pickupPoint.store.forcePrinterSelection)
        {
          this.setState({forcePrinterSelection:order.node.cart.pickupPoint.store.forcePrinterSelection});
        }
      } catch(error) {
          console.log("forcePrinterSelection error", error);

      }
      if(order.node.deliveryPersonPhone)
      {
        this.setState({deliveryPersonPhone:order.node.deliveryPersonPhone});
        
      }
      if(order.node.deliveryPersonFirstName)
        {
          this.setState({deliveryPersonFirstName:order.node.deliveryPersonFirstName});
          
        }
   
      //---end line--
      if (
        this.props.storeInformation.store &&
        this.props.storeInformation.store.barCodeGenerate === true
      ) {
        let obj = {
          BarCodeGenerate: "Y",
        };
        order.BarCodeGenerate = obj;
      } else {
        let obj = {
          BarCodeGenerate: "N",
        };
        order.BarCodeGenerate = obj;
      }

      let ref =
        "intent:#Intent;action=com.androidsrc.launchfrombrowser;category=android.intent.category.DEFAULT;category=android.intent.category.BROWSABLE;S.msg_from_browser=" +
        JSON.stringify(order) +
        ";end";
      let printCount = this.printCount(order);

      this.setState({
        spinnerLoading: false,
        order: order,
        printRef: ref,
        printRollCount: printCount,
      });
    }} else {
      this.setState({
        spinnerLoading: false,
      });

      alert("Something went wrong try again.");
      console.log("Connection to server failed.");
    }
  };

  renderPrintComponent = () => {
    //console.log(this.props.order)
    let vehicleDetails = this.props.order.node.cart.checkout.mode;
    let vehicleString = "Walking";
    if (!!vehicleDetails) {
      vehicleString = vehicleDetails;
      // vehicleString = vehicleDetails.model + " " + vehicleDetails.registration;
    }

    return (
      <div
        style={{ fontWeight: "bold", fontSize: 20, padding: 10 }}
        ref={(printDiv) => {
          this.printDiv = printDiv;
        }}
      >
        <p style={{ margin: 10 }}>GRABBNGO ORDER</p>
        <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          {"Token " + this.props.order.node.storeToken}
        </p>

        <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          {"Mode: " + vehicleString}
        </p>
        {this.props.order.node.cart.checkout.codeType === "AEP" ? (
          <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
            {this.props.order.node.cart.checkout.codeType +
              ": " +
              this.props.order.node.cart.checkout.code}
          </p>
        ) : null}
        {
          // <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          //   {"Pickup Point: " + this.props.order.node.cart.pickupPoint.name}
          // </p>
          // Customer name commented
          //  this.props.order.node.user.userProfile.firstName === null
          // ?
          // null
          // :
          // <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          //   {"User Name: " +
          //     this.props.order.node.user.userProfile.firstName +
          //     " " +
          //     this.props.order.node.user.userProfile.lastName}
          // </p>
          // <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
          // {"User Mobile: " + this.props.order.node.user.phone}
          // </p>
        }

        {this.state.order.node.cart.specialInstructions === null ? null : (
          <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>
            {"Special Instructions: " +
              this.state.order.node.cart.specialInstructions}
          </p>
        )}
        <p style={{ margin: 0, padding: 0 }}>
          {this.getCountOfItems() + " Item(s)"}
        </p>
        <Table responsive style={{ marginTop: 20, marginBottom: 20 }}>
          <tbody>
            <tr style={{ fontWeight: "bold", fontSize: 20 }}>
              <th>Product</th>
              <th>Quantity</th>
              {
                // <th>Amount</th>
                // <th>Status</th>
              }
            </tr>
            {this.state.order.node.cart.cartItems.edges.map((cartItem) => (
              <tr
                key={cartItem.node.id}
                style={{ fontWeight: "bold", fontSize: 20 }}
              >
                <td>
                  <p>{this.getProductName(cartItem)}</p>
                  {cartItem.node.customizations.edges.length > 0 ? (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            padding: 0,
                            fontWeight: "bold",
                          }}
                        >
                          {"Customizations"}
                        </p>
                        {
                          // <p
                          //   style={{
                          //     marginBottom: 10,
                          //     marginTop: 10,
                          //     padding: 0,
                          //     fontWeight: "bold"
                          //   }}
                          // >
                          //   {"Amount"}
                          // </p>
                        }
                      </div>
                      {cartItem.node.customizations.edges.map(
                        (customization) => {
                          return (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <p>
                                {customization.node.parent.name +
                                  " - " +
                                  customization.node.name}
                              </p>
                              {
                                // <p>{"₹" + customization.node.settlementPrice}</p>
                              }
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : null}
                </td>
                <td>{cartItem.node.quantity}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/DetailedOrderCard.js